module.exports = __webpack_public_path__ + "img/background-covid.0901ceb4.png";